module.exports = __webpack_public_path__ + "img/P150T_weapon_153.85384ddd.png";